import axios from "axios";
import AppSettings from "@/appsettings";
import Jwt from "@/models/jwt";

//
// Axios
export const Api = axios.create({
  baseURL: AppSettings.BaseUrl,
});

export function setAuthorizationHeader(token: string) {
  Api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

export function removeAuthorizationHeader() {
  delete Api.defaults.headers.common["Authorization"];
}

const jwt: Jwt = JSON.parse(localStorage.getItem("ucJwt") as string) as Jwt;
if (jwt) {
  setAuthorizationHeader(jwt.accessToken.token);
}
